<template>
  <div :class="classObj" class="app-wrapper">
    <sidebar class="sidebar-container" />
    <div :class="{ hasTagsView: needTagsView }" class="main-container">
      <div :class="{ 'fixed-header': fixedHeader }">
        <navbar />
        <tags-view v-if="needTagsView" />
      </div>
      <app-main />
    </div>
  </div>
</template>

<script>
import { AppMain, Navbar, Sidebar, TagsView } from "./components";
import ResizeMixin from "./mixin/ResizeHandler";
import { mapState } from "vuex";

export default {
  name: "Layout",
  components: {
    AppMain,
    Navbar,
    Sidebar,
    TagsView,
  },
  mixins: [ResizeMixin],
  computed: {
    ...mapState({
      sidebar: (state) => state.app.sidebar,
      device: (state) => state.app.device,
    }),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        mobile: this.device === "mobile",
      };
    },
  },
  data() {
    return { fixedHeader: true, needTagsView: false };
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch("app/closeSideBar");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }

  .main-container {
    min-height: 100%;
    position: relative;
  }

  .sidebar-container {
    height: 100%;
    position: fixed;
    font-size: 0px;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 1001;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .fixed-header {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9;
  }

  // mobile responsive
  .mobile {
    .main-container {
      margin-left: 0px;
    }
    .sidebar-container {
      transition: transform 0.28s;
      width: $sideBarWidth !important;
    }
    &.hideSidebar {
      .sidebar-container {
        pointer-events: none;
        transition-duration: 0.3s;
        transform: translate3d(-$sideBarWidth, 0, 0);
      }
    }
  }
}

.hideSidebar {
  .sidebar-container {
    transition: width 0.2s;
    width: $sideBarMiniWidth;
  }
  .main-container {
    transition: margin-left 0.2s;
    margin-left: $sideBarMiniWidth;
  }

  .fixed-header {
    width: calc(100% - #{$sideBarMiniWidth});
    transition: width 0.2s;
  }
}

.openSidebar {
  .sidebar-container {
    transition: width 0.2s;
    width: $sideBarWidth;
  }

  .main-container {
    transition: margin-left 0.2s;
    margin-left: $sideBarWidth;
  }

  .fixed-header {
    width: calc(100% - #{$sideBarWidth});
    transition: width 0.2s;
  }
}

.mobile .fixed-header {
  width: 100%;
}
</style>
